import { Header3, Header4, Paragraph2, Switch } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { useIsMobileDevice } from '../../hooks';
import * as styles from './styles.css';

export interface ICommunicationTypeProps {
  checked: boolean;
  onChange(formsChecked: boolean): void;
}

export const CommunicationType: React.FC<ICommunicationTypeProps> = ({ checked, onChange }) => {
  const isMobile = useIsMobileDevice();

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <div className={styles['container']} id="communication-type">
      <Switch onChange={handleChange} checked={checked} />
      <div {...mergeStyles(styles['content'], isMobile && styles['content-mobile'])}>
        {isMobile ? (
          <Header4 as="span" color="black_100" fontWeight="bold">
            Скрыть номер телефона
          </Header4>
        ) : (
          <Header3 as="span" color="black_100" fontWeight="bold">
            Скрыть номер телефона
          </Header3>
        )}
        <div className={styles['description']}>
          <Paragraph2 as="p" color="black_100" fontWeight="normal">
            Опросим кандидатов и&nbsp;отправим вам их анкеты — общайтесь только с&nbsp;теми, кого выберете. Это
            бесплатно.
          </Paragraph2>
        </div>
      </div>
    </div>
  );
};
